import { render, staticRenderFns } from "./public-post-card.vue?vue&type=template&id=725aa31a&scoped=true&"
import script from "./public-post-card.ts?vue&type=script&lang=ts&"
export * from "./public-post-card.ts?vue&type=script&lang=ts&"
import style0 from "./public-post-card.scss?vue&type=style&index=0&id=725aa31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725aa31a",
  null
  
)

export default component.exports